module.exports = function ($provide) {
    $provide.decorator('$location', [
        '$delegate', function ($location) {
            $location.pathAndSearch = function () {
                const url = $location.url();
                if (url) {
                    return url.split('#')[0];
                }

                return url;
            };

            return $location;
        },
    ]);
};



// WEBPACK FOOTER //
// ./src/configuration/location.js